import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {IBookingViewModel} from "../../services/booking/models/booking-view-model.interface";
import {useServices} from "../../hooks/use-services.hook";
import {TicketSegmentComponent} from "./segments/ticket-segment.component";
import {getPageVerticalGap} from "./print-ticket.helpers";
import {TicketJourneyComponent} from "./journeys/ticket-journey.component";
import {TicketGrandTotalComponent} from "./journeys/ticket-grand-total.component";
import {TicketPageHeaderComponent} from "./common/ticket-page-header.component";
import {TicketPrintDateComponent} from "./segments/ticket-print-date.component";
import {TicketBookingContactComponent} from "./segments/ticket-booking-contact.component";
import {TicketBookingLevelFeesComponent} from "./journeys/ticket-booking-level-fees.component";


interface PrintTicketComponentProps {
    booking: IBookingViewModel;
    elementRef?: React.MutableRefObject<HTMLDivElement | null>;
    withPrices: boolean;

}
export const TicketComponent: React.FC<PrintTicketComponentProps> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: "flex",
        flexDirection: "column",
        gap: getPageVerticalGap(theme),
        width: '100%',
        fontSize: services.theme.currentTheme.fontSize.h5,
        lineHeight: 1.1,
    };




    const renderSegments = () => {
        const segments = props.booking.getAllUnFilteredSegments();
        return (
            <>
                <TicketPageHeaderComponent booking={props.booking}/>
                <TicketPrintDateComponent printDate={printDate}/>
                <TicketBookingContactComponent bookingContact={props.booking.contact}/>
                {
                    segments.map((s, i) => <TicketSegmentComponent key={"SEGMENT_" + s.segmentKey}
                                                                   booking={props.booking}
                                                                   segment={s}/>
                    )
                }
            </>
        );
    }

    const renderJourneys = () => {
        const journeysContainerStyle: CSSProperties = {
            pageBreakBefore: 'always',
            breakBefore: "always",
            display: "flex",
            flexDirection: "column",
            gap: getPageVerticalGap(theme),
            width: '100%'
        }


        if(!props.withPrices) {
            return null;

        }

        const journeysCarts = props.booking.shoppingCart.journeysAllPurchases;
        return (
            <div style={journeysContainerStyle}>
                <TicketPageHeaderComponent booking={props.booking}/>
                <TicketPrintDateComponent printDate={printDate}/>


                {journeysCarts.map((j, i) => <TicketJourneyComponent key={"JOURNEY_" + j.journeyKey} printDate={printDate}
                                                                     booking={props.booking}
                                                                     journeyCart={j}
                                                                     isLastOne={i === journeysCarts.length - 1}/>
                )}
                <TicketBookingLevelFeesComponent booking={props.booking}/>
                <TicketGrandTotalComponent key={"GRAND_TOTAL"} booking={props.booking}/>
            </div>
        );

    }



    const printDate = services.time.currentDate;

    return (
        <div style={styles} ref={props.elementRef}>

            {renderSegments()}

            {renderJourneys()}

        </div>
    )
})